import { useCallback, useEffect, useRef } from 'react';

export default function useRecordingDuration(isPaused: boolean): () => number {
  const accumulatedMsRef = useRef(0);
  const segmentStartRef = useRef<number | null>(null);

  useEffect(() => {
    if (isPaused) return () => {};
    segmentStartRef.current = Date.now();
    return () => {
      if (segmentStartRef.current === null) return;
      accumulatedMsRef.current += Date.now() - segmentStartRef.current;
      segmentStartRef.current = null;
    };
  }, [isPaused]);

  return useCallback(() => {
    const currentSegmentMs =
      segmentStartRef.current === null
        ? 0
        : Date.now() - segmentStartRef.current;
    return accumulatedMsRef.current + currentSegmentMs;
  }, []);
}
